import { Buffer } from 'buffer';

export const usePassStore = defineStore('pass', {
  state: () => {
    return {
      pass: null,
      customer: null
    }
  },
  actions: {
    setDetails({ pass }) {
      this.pass = pass
    },
    setCustomer(customer) {
      this.customer = customer
    },
    setPassDetails({ pass }) {
      this.setDetails({ pass })
    },
    async setFromUrlQuery(query = {}) {
      const { $api } = useNuxtApp()

      const currentQuery = this.urlQuery

      if (query.pass && currentQuery.pass !== query.pass) {
        const json = Buffer.from(query.pass, 'base64').toString()
        const passJSON = JSON.parse(json)

        let pass = null
        if (passJSON.pass && passJSON.pass.id) {
          if (this.pass && this.pass.id === passJSON.pass.id) {
            pass = this.pass
          } else {
            const passResult = await $api.pass.pass(passJSON.pass.id)
            pass = passResult.pass
          }
        }
        this.setDetails({ pass })
      }

      if (query.customer && currentQuery.customer !== query.customer) {
        const json = Buffer.from(query.customer, 'base64').toString()
        const customer = JSON.parse(json)

        this.setCustomer(customer)
      }
    }
  },
  getters: {
    urlQuery(state) {
      const query = {}

      const pass = {}

      if (state.pass) {
        pass.pass = { id: state.pass.id }
      }

      query.pass = Buffer.from(JSON.stringify(pass)).toString('base64')

      if (state.customer) {
        query.customer = Buffer.from(JSON.stringify(state.customer)).toString('base64')
      }

      return query
    }
  }
})
